import Axios from "axios";
import ServerRequest from "./ServerRequest";

export default class AxiosRequest implements ServerRequest {

    public constructor(private readonly rootUrl: string) {
        if (!rootUrl.endsWith('/')) {
            throw new Error('Root URL must end with /');
        }
    }

    public async get<T>(path: string): Promise<T> {
        const response = await Axios.get<T>(this.appendPath(path));
        return response.data;
    }

    private appendPath(path: string): string {
        return this.rootUrl + path;
    }
}
